module.exports = __webpack_public_path__ + "static/media/Photo7.ab955a9a.jpg";